/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';

import { DefenceSecurityAffiliatesRule } from 'landing-pages/defence-security/sections/DefenceSecurityAffiliatesRule/DefenceSecurityAffiliatesRule';
import { DefenceSecurityCoverage } from 'landing-pages/defence-security/sections/DefenceSecurityCoverage/DefenceSecurityCoverage';
import { DefenceSecurityDesks } from 'landing-pages/defence-security/sections/DefenceSecurityDesks/DefenceSecurityDesks';
import { DefenceSecurityFaq } from 'landing-pages/defence-security/sections/DefenceSecurityFaq/DefenceSecurityFaq';
import { DefenceSecurityHero } from 'landing-pages/defence-security/sections/DefenceSecurityHero/DefenceSecurityHero';
import { DefenceSecurityMonitoring } from 'landing-pages/defence-security/sections/DefenceSecurityMonitoring/DefenceSecurityMonitoring';
import { DefenceSecurityObligations } from 'landing-pages/defence-security/sections/DefenceSecurityObligations/DefenceSecurityObligations';
import { DefenceSecurityProvenance } from 'landing-pages/defence-security/sections/DefenceSecurityProvenance/DefenceSecurityProvenance';
import { DefenceSecuritySupplyChain } from 'landing-pages/defence-security/sections/DefenceSecuritySupplyChain/DefenceSecuritySupplyChain';
import { DefenceSecurityVendorReview } from 'landing-pages/defence-security/sections/DefenceSecurityVendorReview/DefenceSecurityVendorReview';

import styles from './DefenceSecurityPage.module.scss';

import { getAccessRoutes } from './DefenceSecurityPage.data';

export const DefenceSecurityPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <DefenceSecurityHero />
      <DefenceSecurityAffiliatesRule />
      <DefenceSecuritySupplyChain />
      <DefenceSecurityDesks />
      <DefenceSecurityObligations />
      <DefenceSecurityMonitoring />
      <DefenceSecurityProvenance />
      <DefenceSecurityCoverage />
      <DefenceSecurityVendorReview />
      <AccessRoutes
        background="light"
        introCard
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset. Pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <DefenceSecurityFaq />
    </div>
  );
};
